import { z } from 'zod';
import { IntegrationStatus, IntegrationType } from '../enums';

export const integrationSchema = z.object({
  id: z.string(),
  integrationType: z.enum([
    IntegrationType.GMAIL,
    IntegrationType.GOOGLE_DRIVE,
    IntegrationType.SLACK,
    IntegrationType.CANVA,
    IntegrationType.FATHOM,
  ]),
  status: z.enum([
    IntegrationStatus.CREATED,
    IntegrationStatus.ENABLED,
    IntegrationStatus.DISABLED,
    IntegrationStatus.ERROR,
  ]),
  lastRun: z.coerce.date().nullable(),
  description: z.string().nullable().optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type IntegrationSchema = z.infer<typeof integrationSchema>;
